<template>
  <el-table :data="tableData" border>
    <el-table-column :label="$t('lang.标题')" align="center">
      <template v-slot="{row}">
        <nation-input size="small" :placeholder="$t('lang.标题')"  v-model="row.langs" :disabled="isDisabled" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('lang.图片')" align="center">
      <template v-slot="{row}">
        <el-upload
            v-if="state != 'check'"
            :action="api.upload"
            :limit="1"
            :file-list="row.fileList"
            :data="{category: 'RECIPE'}"
            :on-success="(res) => handleSuccessUpload(res, row)"
            :on-exceed="handleExceed"
            :on-remove="() => handleRemovePic(row)"
            list-type="picture-card">
          <i class="el-icon-plus"></i>
        </el-upload>

        <el-image :src="api.download + row.picCode" v-else />
      </template>
    </el-table-column>
    <el-table-column label="排序" align="center">
      <template v-slot="{row}">
        <el-input size="small" v-model="row.sortNum" type="number" :disabled="isDisabled"  :placeholder="$t('lang.排序')" />
      </template>
    </el-table-column>
    <el-table-column label="自定义数据" align="center">
      <template v-slot="{row}">
        <el-input size="small" v-model="row.data" :disabled="isDisabled"  :placeholder="$t('lang.自定义数据')" />
      </template>
    </el-table-column>

    <el-table-column align="center" v-if="state != 'check'">
      <template slot="header">
        <el-button type="primary" size="small" @click="handleAddRow">{{ $t('lang.新增') }}</el-button>
      </template>

      <template v-slot="scope">
        <el-button type="primary" size="small" @click="handleSelectRecipe(scope.row)">{{ $t('lang.选择食谱') }}</el-button>
        <el-button type="danger" size="small" @click="handleDeleteRow(scope)">{{ $t('lang.删除') }}</el-button>
      </template>
    </el-table-column>

  </el-table>
</template>

<script>
import {handleFilterLang} from "../../utlis/utlis";
import NationInput from "../nation/NationInput";
export default {
  name: "BannerTable",
  components: {NationInput},
  model: {
    event: "input",
    value: "value"
  },
  props: {
    state: {
      type: String,
      default: "edit", // edit check
    },
    value: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      api: {
        upload: this.$api.file.upload,
        download: this.$api.file.download + "?fileCode=",
      },
      tableData: [],

      fileList: [],
    }
  },
  methods: {
    // 选择食谱
    handleSelectRecipe(row) {
      this.$bus.$off("bannerRecipe");
      this.$bus.$once("bannerRecipe", (recipe) => {
        row.data = recipe.number;
        row.picCode = recipe.photo;
        row.fileList = [{url: this.api.download + recipe.photo}]
      })
      this.$router.push({
        path: "/banner/recipe",
      })
    },

    // 删除图片
    handleRemovePic(row) {
      row.picCode = "";
      row.fileList = [];
    },

    handleExceed() {
      this.$message.warning("最多只能上传一张图片");
    },

    // 上传成功
    handleSuccessUpload(res, row) {
      if(res.status != 200) {
        this.$message.error(res.desc);
        return;
      }
      row.picCode = res.data.fileCode;
    },
    // 删除行
    handleDeleteRow(scope) {
      let index = scope.$index;
      this.tableData.splice(index, 1);
    },

    // 添加row
    handleAddRow() {
      let row = {
        langs: {},
        lang: "",
        picCode: "",
        sortNum: null,
        data: ""
      }

      this.langList.forEach(item => {
        row.langs[item.value] = "";
      })
      row.lang = this.langList[0].value;
      this.tableData.push(row);
    },

    reset() {
      this.tableData = [];
    },

    getData() {
      return this.tableData.map(item => {
        let langs = []
        for (const key in item.langs) {
          langs.push({lang: key, title: item.langs[key]})
        }
        let newItem = {
          langs,
          picCode: item.picCode,
          sortNum: item.sortNum,
          data: item.data,
        }
        return newItem;
      });
    },

    setData(data) {
      this.tableData = data.map(item => {
        let data =  {
          langs: this.handleLangChangeObject(item.langs),
          lang: this.langList[0].value,
          title: item.title,
          picCode: item.picCode,
          sortNum: item.sortNum,
          data: item.data,
          fileList: []
        };

        if(item.picCode) {
          data['fileList'] = [{url: this.api.download + item.picCode}]
        }
        return data;
      });
    },

    // 将多语言转换对象
    handleLangChangeObject(langs) {
      let langObject = {};
      // 回显前需按设置系统语言初始化key
      this.langList.forEach(item => {
        langObject[item.value] = "";
      })

      // 回显已保存的值
      langs.forEach(item => {
        langObject[item.lang] = item.title;
      })
      return langObject;
    },
  },
  computed: {
    isDisabled() {
      return this.state == "check";
    },
    langList() {
      let list = handleFilterLang(this);
      return list || []
    }
  },
}
</script>

<style scoped>

.el-image {
  width: 120px;
  height: 120px;
}

.lang-box {
  display: flex;
  margin-top: 14px;
}

</style>